import { useI18n } from 'app/components/localization';
import SocialIconButtonA from 'app/components/presentation/buttons/SocialIconButtonA';
import Link from 'app/components/router/Link';
import InstagramLogo from 'app/components/svgs/social/InstagramLogo';
import YouTubeLogo from 'app/components/svgs/social/YouTubeLogo';
import { NumericBreakpoint } from 'app/constants/Breakpoints';
import { GREY_B, GREY_S } from 'app/constants/Colors';
import { useClasses } from 'app/utils/css';
import React, { ComponentType, SVGProps } from 'react';
import { usePageBreakpoint } from 'app/components/layout/Breakpoint';
import { useServerYear } from 'app/components/utilities/ServerTime';

export default () => {
  const { t } = useI18n();
  const containerBase = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'stretch',
    alignItems: 'center',
    color: GREY_S,
  } as const;

  const classes = useClasses({
    container: {
      ...containerBase,
      fontSize: '14px',
      padding: '2em 0',
    },
    containerWide: {
      ...containerBase,
      fontSize: '12px',
      padding: '5px',
    },
    privacy: {
      margin: '0 1em',
    },
    privacyLink: {
      color: GREY_B,
      fontWeight: 600,
      textDecoration: 'none',
    },
    space: {
      flexGrow: 1,
    },
    social: {
      display: 'flex',
    },
  });

  const breakpoint = usePageBreakpoint();
  const currentYear = useServerYear();

  return (
    <div className={breakpoint >= NumericBreakpoint.Wide ? classes.containerWide : classes.container}>
      <div>{t('footer.copyright', { currentYear })}</div>

      <div className={classes.space} />

      <div className={classes.privacy}>
        <Link to="https://engoo.com/tutor_privacy_policy" className={classes.privacyLink}>
          {t('footer.privacy-policy')}
        </Link>
      </div>

      <div className={classes.social}>
        <SocialLink href="https://www.instagram.com/engootutors" icon={InstagramLogo} />
        <SocialLink href="https://www.youtube.com/engootutors" icon={YouTubeLogo} />
      </div>
    </div>
  );
};

const SocialLink = ({ href, icon: IconSvg }: { href: string, icon: ComponentType<SVGProps<SVGSVGElement>> }) => {
  const classes = useClasses({
    linkMargin: {
      margin: '8px',
      display: 'inline-block',
    },
    socialIcon: {
      flexGrow: 1,
    },
  });

  return (
    <span className={classes.linkMargin}>
      <SocialIconButtonA>{linkClassName =>
        <Link className={linkClassName} to={href} target="_blank">
          <IconSvg className={classes.socialIcon} />
        </Link>
      }</SocialIconButtonA>
    </span>
  );
};
